module.exports = __webpack_public_path__ + "b9e3d714f42611eb31f421d72228b261.png";


//////////////////
// WEBPACK FOOTER
// ./routes/home/cross-black.png
// module id = 0w4T
// module chunks = 3